import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { getCubejsApi, redirectToLogin } from "../common/Dashboard/cubejs-util";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";

export default function SensitivityInformation() {
  const cubejsApi = getCubejsApi();

  const [data, setData] = useState({
    initial: [],
    deep: [],
    native: [],
  });

  const [loader, setLoader] = useState(false);

  const sensitivity = useSelector(
    (state) => state.dataMapReducer.dataMapFilePopUpData
  );

  const sensitivityId =
    sensitivity?.fileId || sensitivity?.[`Contents.sensitivityId`];

  // Confidence formatter (label only + raw for tooltip)
  const formatConfidence = (value) => {
    if (value === null || value === undefined)
      return { label: "-", raw: "" };

    const num = Number(value);
    if (isNaN(num)) return { label: "-", raw: "" };

    let label = "";

    if (num >= 85) label = "Very Likely";
    else if (num >= 60) label = "Likely";
    else label = "Possible";

    return {
      label,
      raw: num,
    };
  };

  useEffect(() => {
    if (isEmpty(sensitivityId)) return;

    const fetchData = async () => {
      setLoader(true);

      try {
        const resultSet = await cubejsApi.load({
          dimensions: [
            "SensitivityModel.sensitivityId",
            "SensitivityModel.sourceCode",
            "SensitivityModel.dataSensitivityType",
            "SensitivityModel.informationType",
            "SensitivityModel.label",
            "SensitivityModel.category",
            "SensitivityModel.confidence",
          ],
          filters: [
            {
              member: "SensitivityModel.sensitivityId",
              operator: "equals",
              values: [sensitivityId],
            },
          ],
        });

        const response = resultSet.rawData();

        const grouped = {
          initial: [],
          deep: [],
          native: [],
        };

        const presidio = [];

        response.forEach((item) => {
          switch (item[`SensitivityModel.sourceCode`]) {
            case "HEURISTICS":
              grouped.initial.push(item);
              break;
            case "GCP":
              grouped.deep.push(item);
              break;
            case "SQL SERVER":
              grouped.native.push(item);
              break;
            case "PRESIDIO":
              presidio.push(item);
              break;
            default:
              break;
          }
        });

        // fallback: deep → presidio
        if (isEmpty(grouped.deep) && !isEmpty(presidio)) {
          grouped.deep = presidio;
        }

        setData(grouped);
      } catch (error) {
        redirectToLogin(error);
      } finally {
        setLoader(false);
      }
    };

    fetchData();
  }, [sensitivityId]);

  // ✅ Reusable table renderer
  const renderTable = (title, rows, isNative = false) => {
    if (isEmpty(rows)) return null;

    return (
      <div className="sensitivity-classification">
        {title}:
        <TableContainer className="classification-table-container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="classification-table-cell type-header">
                  Type
                </TableCell>
                <TableCell className="classification-table-cell type-header">
                  {isNative ? "Label" : "Information Type"}
                </TableCell>
                {/* will do in future */}
                {/* <TableCell className="classification-table-cell type-header">
                  Confidence
                </TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => {
                const confidence = formatConfidence(
                  row[`SensitivityModel.confidence`]
                );

                return (
                  <TableRow key={index}>
                    <TableCell className="classification-table-cell">
                      {row[`SensitivityModel.dataSensitivityType`] || "-"}
                    </TableCell>

                    <TableCell className="classification-table-cell">
                      {isNative
                        ? row[`SensitivityModel.label`] || "-"
                        : row[`SensitivityModel.informationType`] || "-"}
                    </TableCell>
                    {/* will do in future */}
                    {/* <TableCell className="classification-table-cell">
                      <Tooltip title={confidence.raw || "No value"}>
                        <span>{confidence.label}</span>
                      </Tooltip>
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  const noData =
    isEmpty(data.initial) &&
    isEmpty(data.deep) &&
    isEmpty(data.native);

  return (
    <>
      {loader && (
        <img
          src={Page_Loader}
          alt="loading"
          className="loader-data-source oneDrive-Table"
        />
      )}

      {noData ? (
        <>No Data Available</>
      ) : (
        <>
          {renderTable("Initial Classification", data.initial)}
          {renderTable("Deep Classification", data.deep)}
          {renderTable("Native Classification", data.native, true)}
        </>
      )}
    </>
  );
}